import type { TagDefinition, TagRegistry } from './tagRegistry'

// Local copy of createStableTagId — a runtime import from tagRegistry would create an
// import cycle (tagRegistry → canonicalRatingTags → this file → tagRegistry).
function stableId(seed: string): string {
  let hash = 2166136261
  for (let i = 0; i < seed.length; i++) {
    hash ^= seed.charCodeAt(i)
    hash = Math.imul(hash, 16777619) >>> 0
  }
  return `tag_${hash.toString(36)}`
}

/**
 * Canonical "Pinned" tag — the author marks a ChapterSection whose position in the
 * reader sequence is settled ("iron"). Purely informational: it never blocks moving
 * the section. Stored through the regular section-tags annotation, so it round-trips
 * to the content-repo sidecars where editing sessions can read it.
 */
export const PINNED_TAG_ID = stableId('manifesto.section.pinned')

export const PINNED_TAG_NAME = 'מקובע'

export const PINNED_TAG_DEFAULT: TagDefinition = {
  name: PINNED_TAG_NAME,
  parentIds: [],
  description: 'המיקום של המקטע ברצף סגור — המחבר שלם איתו',
  color: '#C9A227',
  order: 26,
}

export function ensureProtectedPinnedTag(registry: TagRegistry): TagRegistry {
  const existing = registry.tags[PINNED_TAG_ID]
  const next: TagDefinition = {
    ...PINNED_TAG_DEFAULT,
    ...(existing?.hidden ? { hidden: true } : {}),
  }
  if (existing && JSON.stringify(next) === JSON.stringify(existing)) {
    return registry
  }
  return { ...registry, tags: { ...registry.tags, [PINNED_TAG_ID]: next } }
}
